import React, { useEffect, useState } from 'react';
import QuizCard from '../free-quizzes-data/QuizCard';
import QuizFilter from '../free-quizzes-data/QuizFilter';
import QuizHeader from '../free-quizzes-data/QuizHeader';
import { axiosRequest } from '../../../_config/apiClient';
import { FiHelpCircle } from "react-icons/fi";


const FreeQuizzes = () => {
  // const quizzes = Array(12).fill({
  //   examType: "IB MTS",
  //   title: "IB MTS: Logical Ability - Secret Warriors Quiz",
  //   questions: 5,
  //   marks: 5,
  //   time: 30
  // });

  const [category, setCategory] = useState([]);
  const [categoryResponse, setCategoryResponse] = useState(null);
  const [quizList, setQuizList] = useState([]);

  useEffect(() => {
    fetchQuezeCategoryList();
  }, []);

  useEffect(() => {
    fetchQuizListByCategory();
  }, [categoryResponse]);

  const fetchQuezeCategoryList = async () => {
    try {
      const res = await axiosRequest("post", "/user/quezeCategoryList", {}, {
        Authorization: `Bearer ${localStorage.getItem("user")}`,
      });
      console.log("Category List:", res.data);
      setCategory(res.data)
      const response = res?.data?.[0]?.subCategories?.[0]?.name ?? null
      console.log('response', response);
      setCategoryResponse(response)
    } catch (err) {
      console.log("Error:", err.message);
    }
  };

  const fetchQuizListByCategory = async () => {
    try {
      const res = await axiosRequest("post", "/user/QuizListByCategory", { category: categoryResponse }, {
        Authorization: `Bearer ${localStorage.getItem("user")}`,
      });
      console.log("res:", res.data);
      setQuizList(res.data)
    } catch (err) {
      console.log("Error:", err.message);
    }
  }

  return (
    <div className="animate-in fade-in slide-in-from-bottom-2 duration-500 pb-10">
      <QuizHeader />

      <div className="px-2 md:px-1 mb-6 md:mb-8 text-left sm:text-center md:text-left leading-relaxed">
        <p className="text-[#33333399] text-[14px] md:text-[18px] font-[500] tracking-[-1px] font-inter">
          Test your knowledge and concepts with specially designed Daily Free Quizzes!
        </p>
        <p className="text-[#33333399] text-[14px] md:text-[18px] font-[500] tracking-[-1px]  font-inter ">
          Get your All India Rank among lakhs of students and track your progress.
        </p>
      </div>

      <h2 className="text-[18px] md:text-[20px] font-[500] text-[#333333] tracking-tight mb-5 md:mb-6 font-inter text-left px-2 md:px-0">
        Explore Quizzes for your Exam Preparation
      </h2>

      <div className="flex flex-col lg:flex-row gap-6 md:gap-8 px-2 md:px-0">
        <div className="w-full lg:w-auto">
          <QuizFilter category={category} setCategoryResponse={setCategoryResponse} />
        </div>
        <div className="flex-1 w-full space-y-4">
          {quizList && quizList.length > 0 ? quizList.map((quiz, index) => (
            <QuizCard key={index} quiz={quiz} />
          )) : (
            <div className="w-full flex flex-col items-center justify-center py-16 text-center">
              <FiHelpCircle className="text-[48px] text-gray-400 mb-4" />
              <h2 className="text-[18px] md:text-[20px] font-[500] text-gray-700 mb-2">
                No quizzes found
              </h2>
              <p className="text-[14px] md:text-[16px] text-gray-500 max-w-md">
                No quizzes are available for this category right now.
                Please check back again later 🙂
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default FreeQuizzes;